/**
 * Компонент для prefetch маршрутов
 * Предзагружает данные для соседних маршрутов
 */

import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { logWarn } from '../shared/config/constants';

interface RoutePrefetchConfig {
  [key: string]: () => void;
}

interface RoutePrefetchProps {
  config: RoutePrefetchConfig;
  delay?: number;
}

/**
 * Предзагрузка данных для маршрутов
 */
export const RoutePrefetch: React.FC<RoutePrefetchProps> = ({ config, delay = 1000 }) => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    // Задержка перед prefetch чтобы не блокировать текущую загрузку
    const timeoutId = setTimeout(() => {
      Object.entries(config).forEach(([path, prefetchFn]) => {
        // Prefetch только соседние маршруты
        if (isAdjacentRoute(currentPath, path)) {
          try {
            prefetchFn();
          } catch (error) {
            logWarn(`Prefetch failed for ${path}`, error);
          }
        }
      });
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, config, delay]);

  return null;
};

/**
 * Определяет являются ли маршруты соседними
 */
function isAdjacentRoute(currentPath: string, targetPath: string): boolean {
  const routes = ['/trading', '/agents', '/statistics'];

  const currentIndex = routes.findIndex(route => currentPath.startsWith(route));
  const targetIndex = routes.findIndex(route => targetPath.startsWith(route));

  if (currentIndex === -1 || targetIndex === -1) {
    return false;
  }

  // Соседние маршруты (разница в индексе <= 1)
  return Math.abs(currentIndex - targetIndex) <= 1;
}

/**
 * Prefetch конфигурация для основных маршрутов
 */
// NOTE: Конфигурацию prefetch задаём рядом с Layout/Router (где она реально используется),
// чтобы этот файл экспортировал только компонент (React Refresh).
